/**
 * Applies a relative drop bonus to an integer count. Stochastic rounding, so a bonus too small to
 * yield a whole extra item still pays out at the right rate over many rolls. Exactly identity when
 * bonus is 0, leaving baseline drop rates untouched.
 */
export default function applyLootBonusToCount(count: number, bonus: number): number {
  const target = count * Math.max(0, 1 + bonus);
  const whole = Math.floor(target);
  return Math.max(0, whole + (Math.random() < target - whole ? 1 : 0));
}
